import { useLinked } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { InblockedCreditNotesDataStep } from "../creditnotes/inblocked-credit-notes-data-step";
import { InblockedInvoicesDataStep } from "../invoices/inblocked-invoices-data-step";
import { InblockedUnappliedCashesDataStep } from "../unapplied-cashes/inblocked-unapplied-cashes-data-step";

export const InblockedMultiAssetsDataStep = ({ job, back, assetTypeMultiOptions, $refreshEvents }: { job, back?, assetTypeMultiOptions, $refreshEvents }) => {
    const $assetTypeSelect = useLinked({ id: AssetType.invoice, name: 'Invoice' });

    const isInvoiceDataStep = (assetType) => {
        return assetType === AssetType.invoice;
    }

    const isCreditNoteDataStep = (assetType) => {
        return assetType === AssetType.creditNote;
    }

    const isUnappliedCashDataStep = (assetType) => {
        return assetType === AssetType.unappliedCash;
    }

    return <>
        {isInvoiceDataStep($assetTypeSelect.value.id) && <InblockedInvoicesDataStep job={job} back={back} $assetTypeSelect={$assetTypeSelect} assetTypeMultiOptions={assetTypeMultiOptions} $refreshEvents={$refreshEvents} height={400} />}
        {isCreditNoteDataStep($assetTypeSelect.value.id) && <InblockedCreditNotesDataStep job={job} back={back} $assetTypeSelect={$assetTypeSelect} assetTypeMultiOptions={assetTypeMultiOptions} $refreshEvents={$refreshEvents} height={400} />}
        {isUnappliedCashDataStep($assetTypeSelect.value.id) && <InblockedUnappliedCashesDataStep job={job} back={back} $assetTypeSelect={$assetTypeSelect} assetTypeMultiOptions={assetTypeMultiOptions} $refreshEvents={$refreshEvents} height={400} />}
    </>
};
